<template>
  <div id="preview" class="SubPrintReward">
    <div class="titlename">代理商消費紀錄統計表 - {{name}}</div>
    <table>
      <thead>
        <tr>
          <th>項次</th>
          <th>日期</th>
          <th >團(平)</th>
          <th >團(假)</th>
          <th >優惠</th>
          <th >其他</th>
          <th>團體人次</th>
          <th>總人次</th>
          <th>門票總金額</th>
          <th>二消總金額</th>
          <th>總金額</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="({ _id: date, ticket1, ticket2, ticket3, ticketGroupOther, ticketAllGroup, count, re1, re2, total }, r) in records" :key="r">
          <td>{{r+1}}</td>
          <td :style="{textAlign: 'center'}">{{toDate(date)}}</td>
          <td>{{ticket1||'-'}}</td>
          <td>{{ticket2||'-'}}</td>
          <td>{{ticket3||'-'}}</td>
          <td>{{ticketGroupOther||'-'}}</td>
          <td>{{ticketAllGroup||'-'}}</td>
          <td>{{count}}</td>
          <td>{{formatDollarInt(re1)}}</td>
          <td>{{formatDollarInt(re2)}}</td>
          <td :style="{textAlign:'end'}">{{formatDollarInt(total)}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr :style="{borderBottom: '1px solid #CACACA'}"></tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  props: ['records', 'name']

}
</script>

<style scoped>
table {
  border: 1px solid #CACACA;
  border-collapse: collapse;
}
thead tr {
  background-color: rgb(240, 240, 240);
}
th {
  padding-inline: .5em;
  height: 40px;
}
td {
  border-right: 1px solid #CACACA;
  height: 40px;
  padding-inline: .5em;
}

#preview {
  display: flex;
  flex-direction: column;
  gap: 21px;
  position: fixed;
  top: -60px;
  left: -100vw;
  background-color: #FFFFFF;
  width: 297mm;
  height: 210mm;
  transform: scale(.85);
  z-index: 100;
  padding: 30px 50px;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}
.titlename {
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
